// Grid layout — single temperature chart
export const LEGEND_WIDTH = 160
export const LANE_LABEL_WIDTH = 150

export const GRID_SHARED = {
  left: 60,
  right: 30,
} as const

export const VIOLATION_COLOR = '#eab308' // yellow-500

export const GEOFENCE_OPACITY = 0.12

// CIT overlay opacity on temperature chart
export const CIT_OVERLAY_OPACITY = 0.15

/** Silence in a reefer state stream (ms) that counts as downtime. State is logged only
 *  while the unit reports, so a gap this large means it was off — the status bars show a
 *  hole over it rather than painting a solid bar across the downtime. */
export const MODE_GAP_MS = 120 * 60 * 1000

/** Single-grid layout: vertical pitch between status lanes, as a fraction of the temperature
 *  data range. Proportional (not a fixed degree count) so lane spacing is unit-independent. */
export const LANE_GAP_FRACTION = 0.08

/** Status rows under the graph (a second grid sharing the time axis): pixel height per
 *  row, bar thickness, the strip for the graph's time labels, the gap between the grids and
 *  the padding under the last row. */
export const STATUS_ROW_PX = 18
export const STATUS_BELOW_BAR_PX = 10
export const STATUS_AXIS_PX = 56 // 3-line time/date/tz axis
export const STATUS_GRID_GAP = 8
export const STATUS_BELOW_PAD_PX = 8
export const STATUS_GRID_LEFT = 96 // the tracker graph's left inset for row labels

/** Left inset of the plot when status lanes or rows are labelled in the gutter. Both grids
 *  use it so their time axes line up. */
export const STATUS_LABEL_LEFT = 120

/** Floor for the chart canvas once the measured navigation bar is subtracted from the
 *  caller's height budget. Prevents a tall nav in a short card from producing a
 *  zero-height (blank, silent) canvas — the nav overflows visibly instead. */
export const MIN_CHART_CANVAS_PX = 180

/** Series names for the asset's configured temperature threshold lines. Underscore-
 *  wrapped like the other non-data series (`__geofence__`) so they can't collide with
 *  a zone or monitoring-point name. Also the legend toggle keys. */
export const TEMP_LIMIT_UPPER_SERIES = '__temp_limit_upper__'
export const TEMP_LIMIT_LOWER_SERIES = '__temp_limit_lower__'

/** Matching the tracker graph's shipment-range lines: red ceiling,floor. */
export const TEMP_LIMIT_UPPER_COLOR = '#ef4444'
export const TEMP_LIMIT_LOWER_COLOR = '#ef4444'
